import React from 'react';
import { Alert } from 'react-bootstrap';

const AlertMessage = ({alert,setAlert}) => {
    
    return (
        <>
            {alert.show && (
                <Alert
                    variant={alert.variant}
                    defaultChecked
                    className="position-fixed text-center"
                    style={{ top: "10px",right: '15%',width: "70%",overflow: 'hidden', zIndex: 1080 }}
                    dismissible
                    onClose={() => setAlert((prev) => ({ ...prev, show: false }))}
                >
                    {alert.message}
                </Alert>
            )}
        </>
    )
}

export default AlertMessage;
